// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legend_legend__foDBs","link":"Legend_link__tcApQ","active":"Legend_active__CjrFc"};